module.exports = __webpack_public_path__ + "img/portrait-033.42430a94.jpg";